import clsx from "clsx";
import { errorTextID, labelID } from "../utils";
import { FieldsError } from "./Error";

interface FieldsCheckboxProps {
  id: string;
  labelText?: string;
  errorText?: string[];
  values: string[];
  disabled?: boolean;
  name?: string;
}

export function FieldsCheckboxGroup({ id, labelText, errorText, disabled, values, name }: FieldsCheckboxProps) {
  return (
    <div>
      <fieldset
        disabled={disabled}
        className={clsx("flex", "flex-col", "space-y-2")}
        aria-labelledby={labelID(id)}
        aria-describedby={errorTextID(id)}
        aria-invalid={errorText ? "true" : undefined}
      >
        {errorText && <FieldsError id={errorTextID(id)}>{errorText}</FieldsError>}
        <legend
          id={labelID(id)}
          className={clsx(
            "relative",
            "block",
            "font-sans",
            "font-bold",
            "text-base",
            "text-gray-700",
            "leading-none",
            "tracking-tight",
            "mb-2"
          )}
        >
          {labelText}
        </legend>
        <div className={clsx("grid", "gap-3", "grid-cols-2", "md:grid-cols-4")}>
          {values.map((value, index) => (
            <label
              key={index}
              htmlFor={`${id}[${index}]`}
              className={clsx(
                "flex",
                "items-start",
                "col-span-1",
                "font-sans",
                "font-normal",
                "text-base",
                "leading-normal",
                "text-gray-700",
                !disabled && "cursor-pointer",
                disabled && ["cursor-not-allowed", "opacity-50"]
              )}
            >
              <input
                id={`${id}[${index}]`}
                type="checkbox"
                value={value}
                className={clsx("mr-1", "h-[1.5rem]")}
                name={name}
              />
              <span className="block">{value}</span>
            </label>
          ))}
        </div>
      </fieldset>
    </div>
  );
}
